import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Upload } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

const GameForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    name: '', description: '',
    category_id: '', gameType: 'offline', icon: '🎮',
    thumbnail: '', gameUrl: '',
    minPlayers: 1, maxPlayers: 1, isActive: true, isFeatured: false,isLandscape:false
  });

  useEffect(() => {
    fetchCategories();
    if (id) fetchGame();
  }, [id]);

  const fetchCategories = async () => {
    const { data } = await api.get('/categories');
    setCategories(data.data);
  };

  const fetchGame = async () => {
    try {
      const { data } = await api.get(`/games/${id}`);
   console.log(data); 
    setFormData(prev => ({
  ...prev,                // keep existing state
  ...data.data,            // merge new data
  category_id: data.data?.category?.id || ''  
}));
    } catch (error) {
      toast.error('Error loading game');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await api.put(`/games/${id}`, formData);
        toast.success('Game updated successfully');
      } else {
        await api.post('/games', formData);
        toast.success('Game created successfully');
      }
      navigate('/games');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error saving game');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <button onClick={() => navigate('/games')} className="flex items-center gap-2 text-gray-400 hover:text-white">
        <ArrowLeft size={20} /> Back to Games
      </button>

      <div>
        <h1 className="text-3xl font-bold mb-2">{id ? 'Edit Game' : 'Add New Game'}</h1>
        <p className="text-gray-400">Fill in the game details below</p>
      </div>

      <form onSubmit={handleSubmit} className="gradient-card border border-gray-800 rounded-xl p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium mb-2">Game Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Description</label>
            <textarea name="description" value={formData.description} onChange={handleChange} required rows={4}
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
          </div>
        </div>

       

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium mb-2">Category</label>
            <select name="category_id" value={formData.category_id} onChange={handleChange} required
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white">
              <option value="">Select Category</option>
              {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Game Type</label>
            <select name="gameType" value={formData.gameType} onChange={handleChange}
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white">
              <option value="offline">Offline</option>
              <option value="online">Online</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Icon Emoji</label>
            <input type="text" name="icon" value={formData.icon} onChange={handleChange}
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white text-center text-3xl" />
          </div>
        </div>

        

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium mb-2">Game URL</label>
            <input type="url" name="gameUrl" value={formData.gameUrl} onChange={handleChange}
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
          </div>
        <div>
          <label className="block text-sm font-medium mb-2">Thumbnail URL</label>
          <input type="url" name="thumbnail" value={formData.thumbnail} onChange={handleChange} required
            className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white"
            placeholder="https://example.com/image.jpg" />
        </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium mb-2">Min Players</label>
            <input type="number" name="minPlayers" value={formData.minPlayers} onChange={handleChange} min="1"
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Max Players</label>
            <input type="number" name="maxPlayers" value={formData.maxPlayers} onChange={handleChange} min="1"
              className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
          </div>
        </div>

        <div className="flex items-center gap-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" name="isActive" checked={formData.isActive} onChange={handleChange}
              className="w-5 h-5 bg-dark border-gray-700 rounded" />
            <span className="text-sm font-medium">Active</span>
          </label>
           <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" name="isLandscape" checked={formData.isLandscape} onChange={handleChange}
              className="w-5 h-5 bg-dark border-gray-700 rounded" />
            <span className="text-sm font-medium">LandScape</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" name="isFeatured" checked={formData.isFeatured} onChange={handleChange}
              className="w-5 h-5 bg-dark border-gray-700 rounded" />
            <span className="text-sm font-medium">Featured</span>
          </label>
        </div>

        <div className="flex gap-4 pt-4">
          <button type="submit" className="flex-1 py-3 gradient-primary text-white font-semibold rounded-lg hover:opacity-90">
            {id ? 'Update Game' : 'Create Game'}
          </button>
          <button type="button" onClick={() => navigate('/games')}
            className="px-8 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default GameForm;

